import { Link } from 'react-router-dom';
import './styles.css'

import iconFb from './../../images/icon-fb.svg'
import iconLinkedin from './../../images/icon-in.svg'
import iconTwitter from './../../images/icon-tw.svg'

function UpperNav({ modularClass }) {
  return(
    <nav className={`uppernav ${modularClass}`}>
      <ul className="uppernav__list" >
        <div>
        <li className="uppernav__socialitem"><a href="https://www.facebook.com/"><img src={iconFb} alt="facebook"/></a></li>
        <li className="uppernav__socialitem"><a href="https://www.linkedin.com/"><img src={iconLinkedin} alt="linkedin"/></a></li>
        <li className="uppernav__socialitem"><a href="#"><img src={iconTwitter} alt="twitter"/></a></li>
        </div>
        <div>
        <li className="uppernav__listitem"><Link to="/FillVacancy">Employer zone</Link></li>
        <li className="uppernav__listitem"><Link to="/SubmitResume">Submit Resume</Link></li>
        </div>
      </ul>
    </nav>
  )
}

export default UpperNav
